export enum OrderRefundStatus {
    PENDING = "pending",
    FAILED = "failed",
    REFUNDED = "refunded"
}